import React from "react";
import Entity from "../../components/Entity";
import { STATUS, TRUE_FALSE, CLASSIFICATIONS, PROVINCES } from "../../Constants";

function Store() {
  return (
    <Entity
      title={(e) => e.name || "New Store"}
      formShema={{
        fields: [
          { name: "Store Name",      propertyName: "name",           type: "input",  col: 8 },
          { name: "Status",          propertyName: "status",         type: "select", options: STATUS,          isMulti: false, col: 4 },
          { name: "Classification",  propertyName: "classification", type: "select", options: CLASSIFICATIONS, isMulti: false, col: 4 },
          { name: "Territory",       propertyName: "territory",      type: "select", optionsFromServer: "territories", isMulti: false, col: 4 },
          { name: "Banner",          propertyName: "banner",         type: "select", optionsFromServer: "banners",     isMulti: false, col: 4 },
          { name: "Civic No.",       propertyName: "civicNo",        type: "input",  col: 2 },
          { name: "Street",          propertyName: "street",         type: "input",  col: 6 },
          { name: "Office",          propertyName: "office",         type: "input",  col: 4 },
          { name: "City",            propertyName: "city",           type: "input",  col: 4 },
          { name: "Province",        propertyName: "province",       type: "select", options: PROVINCES,       col: 4 },
          { name: "Country",         propertyName: "country",        type: "input",  col: 4 },
          { name: "Postal Code",     propertyName: "postalCode",     type: "input",  col: 4 },
          { name: "Tel. No.",        propertyName: "telNo",          type: "input",  col: 4 },
          { name: "Number",          propertyName: "number",         type: "input",  col: 4 },
          { name: "Web Address",     propertyName: "webAddress",     type: "input",  col: 6 },
          { name: "Visit Frequency", propertyName: "visitFrequency", type: "input",  col: 3 },
          { name: "Corporate",       propertyName: "corpo",          type: "select", options: TRUE_FALSE, isMulti: false, col: 3 },
        ],
      }}
    />
  );
}

export default Store;
